import { FleekError } from "./FleekError";

type SiteMayHaveOneFleekFunctionErrorOptions = { site: { id: string } };

export class SiteMayHaveOneFleekFunctionError extends FleekError<SiteMayHaveOneFleekFunctionErrorOptions> {
  public name = 'SiteMayHaveOneFleekFunctionError';

  toString = () => 'Site may have assigned one Fleek Function at most.';
}